import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { useSelector } from "react-redux";
import { getErrors } from "../../../reducers";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { clearErrors } from "../../../actions/commonActions";

const ErrorSnackbar = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState([]);
    const errors = useSelector(getErrors);

    useEffect(() => {
        setOpen(
            errors
                ?.filter(({ suppressDefault }) => !suppressDefault)
                .map(({ failedAction }) => failedAction) || []
        );
    }, [errors]);

    if (!errors?.length) {
        return null;
    }

    const handleClose = (failedAction, reason) => {
        if (reason !== "clickaway") {
            setOpen(open.filter((action) => failedAction !== action));
        }
        clearErrors(dispatch);
    };

    return (
        <>
            {errors.map((error, index) => (
                <Snackbar
                    key={index}
                    open={open.includes(error.failedAction)}
                    onClose={(event, reason) =>
                        handleClose(error.failedAction, reason)
                    }
                    autoHideDuration={6000}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    sx={{ width: "50%" }}
                >
                    <Alert
                        onClose={(event, reason) =>
                            handleClose(error.failedAction, reason)
                        }
                        severity="error"
                        data-cy="error-alert"
                        sx={{ width: "100%" }}
                        variant="filled"
                        icon={<ErrorOutlineIcon fontSize="medium" />}
                    >
                        {error.errorMessage || "An error has occurred"}
                    </Alert>
                </Snackbar>
            ))}
        </>
    );
};

export default ErrorSnackbar;
